export default ({ request }) => ({
  reportBudgetSetCustListApi(data = {}) {
    return request({
      url: '/financial/report/budget/setCust/list',
      method: 'post',
      data,
    })
  },
  reportBudgetSetCustSaveApi(data = {}) {
    return request({
      url: '/financial/report/budget/setCust/save',
      method: 'post',
      data,
    })
  },
  reportBudgetSetCustDetailApi(data = {}) {
    return request({
      url: '/financial/report/budget/setCust/detail',
      method: 'post',
      data,
    })
  },
  reportBudgetSetCustDelApi(data = {}) {
    return request({
      url: '/financial/report/budget/setCust/del',
      method: 'post',
      data,
    })
  },
})
